export function CheckNumberField(value){
    value = value.split(",").join(".");
    if(value == "") {
        return [false,"Enter data"];
    } else if (!isNaN(value)) {
        let number = parseFloat(value);
        if(number >= 0) {
            return [true,""];
        } else {
            return [false,"Cannot be negative"];
        }
    } else {
        return [false,"No valid data"];
    }   
}

export function CheckYearField(value){
    value.split("+").join("");
    value.split(",").join("");
    value.split(".").join("");
    if(value == "") {
        return [false,"Enter data"];
    } else if(value.length != 4) {
        return [false,"A year must have 4 digits"];
    } else if (!isNaN(value)) {
        let number = parseFloat(value);
        if(number % 1 !== 0) {
            return [false,"A year cannot have a decimal point"];
        } else if(number < 1000) {
            return [false,"No valid data"];
        } else if(number > 0) {
            return [true,""];
        } else {
            return [false,"Cannot be negative"];
        }
    } else {
        return [false,"No valid data"];
    }   
}